// const prod = {
//   url: import.meta.env.REACT_APP_PUBLISH_PATH,
// };
const dev = {
  url: import.meta.env.VITE_BASE_URL,
};

// export const { url } = import.meta.env.MODE === "development" ? dev : prod;
const { url } = dev;
console.info("🚀 ~ APIEndPoints.js:10 ~ url:", url);

export const csrfToken = url + "/api/csrf/csrf-token";

export const getAllAggregateMasterData =
  url + "/api/aggregatemaster/getAllAggregateMasterData";
export const getAggregateMasterDataById =
  url + "/api/aggregatemaster/getAggregateMasterDataById";
export const insertUpdateAggregateMaster =
  url + "/api/aggregatemaster/insertUpdateAggregateMaster";

export const insertUpdateCalendarEvent =
  url + "/api/calendarevent/insertUpdateCalendarEvent";
export const getAllCalendarEventData =
  url + "/api/calendarevent/getAllCalendarEventData";
export const getCalendarEventDataById =
  url + "/api/calendarevent/getCalendarEventDataById";
export const getEventData = url + "/api/getevents/getEventData";
export const getUpcomingData = url + "/api/getevents/getUpcomingEvents";

export const getAllHashtagMasterData =
  url + "/api/hashtagmaster/getAllHashtagMasterData";
export const getHashtagMasterDataById =
  url + "/api/hashtagmaster/getHashtagMasterDataById";
export const insertUpdateHashtagMaster =
  url + "/api/hashtagmaster/insertUpdateHashtagMaster";

export const getAllPlatformMasterData =
  url + "/api/platformmaster/getAllPlatformMasterData";
export const getPlatformMasterDataById =
  url + "/api/platformmaster/getPlatformMasterDataById";
export const insertUpdatePlatformMaster =
  url + "/api/platformmaster/insertUpdatePlatformMaster";
export const insertUpdateGuidelines =
  url + "/api/guidelinesmaster/insertUpdateGuidelines";
export const getAllGuidelineData =
  url + "/api/guidelinesmaster/getAllGuidelineData";
export const getGuidelineDataById =
  url + "/api/guidelinesmaster/getGuidelinesDataById";
export const getGuidelineAllData =
  url + "/api/guidelinesmaster/getGuidelinesAllData";

export const createEventGallery = url + "/api/eventgallery/createEventGallery";
export const getAllEventGalleryMasterData =
  url + "/api/eventgallery/getAllEventGalleryMasterData";
export const getEventGalleryMasterDataById =
  url + "/api/eventgallery/getEventGalleryMasterDataById";

export const getAllBadgeMasterData =
  url + "/api/badgemaster/getAllBadgeMasterData";
export const getBadgeMasterDataById =
  url + "/api/badgemaster/getBadgeMasterDataById";
export const insertUpdateBadgeMaster =
  url + "/api/badgemaster/insertUpdateBadgeMaster";

export const getAllUserRoleMasterData =
  url + "/api/userrolemaster/getAllUserRoleMasterData";
export const getUserRoleMasterDataById =
  url + "/api/userrolemaster/getUserRoleMasterDataById";
export const insertUpdateUserRoleMaster =
  url + "/api/userrolemaster/insertUpdateUserRoleMaster";

export const getCommonDropdownData =
  url + "/api/commonDropdown/getCommonDropdownData";

export const getAllAppVersionMasterData =
  url + "/api/appversionmaster/getAllAppVersionMasterData";
export const getAppVersionMasterDataById =
  url + "/api/appversionmaster/getAppVersionMasterDataById";
export const insertUpdateAppVersionMaster =
  url + "/api/appversionmaster/insertUpdateAppVersionMaster";

export const getAllUsefulLinkMasterData =
  url + "/api/usefullinkmaster/getAllUsefulLinkMasterData";
export const getUsefulLinkMasterDataById =
  url + "/api/usefullinkmaster/getUsefulLinkMasterDataById";
export const insertUpdateUsefulLinkMaster =
  url + "/api/usefullinkmaster/insertUpdateUsefulLinkMaster";

export const deleteDocument = url + "/api/documents/deleteDocument";

export const getAllEventGalleryData = url + "/api/kms/getAllEventGalleryData";
export const getAllUsefulLinkData = url + "/api/kms/v2/getAllUsefulLinksData";
export const getAllKnowledgeBaseData = url + "/api/kms/getAllKnowledgeBaseData";
export const getAllTickerMasterData =
  url + "/api/tickermaster/getAllTickerMasterData";
export const getTickerMasterDataById =
  url + "/api/tickermaster/getTickerMasterDataById";
export const insertUpdateTickerMaster =
  url + "/api/tickermaster/insertUpdateTickerMaster";

export const checkUserDivisionAndRole =
  url + "/api/authentication/checkUserDivision";

export const getHashtagsAutoComplete =
  url + "/api/hashtagmaster/getHashtagAutoSuggest";
export const checkUserDivision = url + "/api/authentication/checkUserDivision";

//dashboard
export const getDashboardData = url + "/api/dashboard/getDashboardData";

export const getKnowledgeDataById = url + "/api/dashboard/getKnowledgeDataById";

export const getKnowledgeHistoryById =
  url + "/api/dashboard/getKnowledgeHistoryById";

export const updateKnowledgeDataById =
  url + "/api/dashboard/updateKnowledgeDataById";

//dashboard

//report

export const getReportData = url + "/api/report/getReportData";

export const getConfigValuesByIds =
  url + "/api/configmaster/getConfigValuesByIds";
export const getAllKnowledgeBaseMasterData =
  url + "/api/knowledgebasemaster/getAllKnowledgeBaseMasterData";
export const getKnowledgeBaseMasterDataById =
  url + "/api/knowledgebasemaster/getKnowledgeBaseMasterDataById";
export const insertUpdateKnowledgeBaseMaster =
  url + "/api/knowledgebasemaster/insertUpdateKnowledgeBaseMaster";
export const getAllknowledgeBasePost =
  url + "/api/knowledgebasepost/getAllKnowledgeBasePost";

export const getFolders = url + "/api/kms/kcbulkupload/getFolders";
export const insertUpdateFolders =
  url + "/api/kms/kcbulkupload/insertUpdateFolders";

export const insertNewGeneratedHashtagsInMaster =
  url + "/api/hashtagmaster/insertNewGeneratedHashtagsInMaster";
export const insertUpdateKCBulkUpload =
  url + "/api/kms/kcbulkupload/insertUpdateKCBulkUpload";

export const getRedirectionUrl = url + "/api/authentication/getRedirectionUrl";

export const getKCUploadDataById =
  url + "/api/kms/kcbulkupload/getKCUploadDataById";

export const uploadaudiovideo = url + "/api/uploadaudiovideo/postVideo";
export const getuploadedvideo = url + "/api/uploadaudiovideo/getVideo";
export const checkDoc = url + "/api/kms/checkDoc";
export const uploadBigVideo = url + "/api/kms/uploadBigVideo";
export const startVideoProcess = url + "/api/kms/startVideoProcess";
export const conversionProgress = url + "/api/kms/conversion-progress";
